import { Button } from '@material-ui/core';
import { PropsWithChildren } from 'react';

import { Dialog, DialogActions, DialogContent, DialogTitle, DialogProps } from '~ui-kit';

type GeneralDialogProps = PropsWithChildren<{
  open: boolean;
  title: string;
  btnCancel: string;
  btnSubmit: string;
  size?: DialogProps['maxWidth'];
  onClose?: () => void;
  onCancel: () => void;
  onSubmit: () => void;
}>;

export const GeneralDialog = ({
  open = false,
  title,
  btnCancel,
  btnSubmit,
  size = 'sm',
  onClose,
  onCancel,
  onSubmit,
  children,
}: GeneralDialogProps) => (
  <Dialog open={open} maxWidth={size}>
    <DialogTitle title={title} onClose={onClose} />
    <DialogContent>{children}</DialogContent>

    <DialogActions>
      <Button variant="outlined" color="primary" onClick={onCancel}>
        {btnCancel}
      </Button>

      <Button variant="contained" color="primary" onClick={onSubmit}>
        {btnSubmit}
      </Button>
    </DialogActions>
  </Dialog>
);
